import { render } from "./MotorList.vue?vue&type=template&id=20118104"
import script from "./MotorList.vue?vue&type=script&lang=js"
export * from "./MotorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__